const { ajaxHandler, debounce } = require("./utilities/utilities");

/**
 * Support search form
 *
 * @since 1.0.0
 */
document.addEventListener('DOMContentLoaded', function () {
    const supportSearch = document.querySelector('.vendora-support-search-wrapper');

    if (supportSearch) {
        const searchInput = supportSearch.querySelector('input[name=search]');
        const clearSearchButton = supportSearch.querySelector('.clear-search-button');
        const searchDropdown = supportSearch.querySelector('.support-search-dropdown');
        const searchDropdownResults = supportSearch.querySelector('.support-search-result');
        const spinner = supportSearch.querySelector('.vendora-spinner-border');

        const handleSearch = debounce(async (value) => {
            spinner.classList.remove('vendora-d-none');

            const response = await fetch(`https://docs.vendora.com/wp-json/h5automation/docs?search=${value}`);
            const data = await response.json();

            let dropdownContent = '';

            if (Array.isArray(data) && data.length > 0) {
                data.forEach(item => {
                    const resultItem = `
                        <a class="search-dropdown-item" href="${item.post_url}" target="_blank">
                            <div class="dropdown-title fw-semibold mb-2">${item.post_title}</div>
                            <p class="mb-0 fs-5">${item.post_excerpt}</p>
                        </a>
                    `;
                    dropdownContent += resultItem;
                });
            } else {
                dropdownContent = '<p class="vendora-no-data-found">No data found!</p>'
            }

            spinner.classList.add('vendora-d-none');
            searchDropdown.classList.remove('vendora-d-none');
            searchDropdownResults.innerHTML = dropdownContent;
        }, 500);

        searchInput.addEventListener('input', (e) => {
            const inputValue = e.target.value;

            if (inputValue.length > 0) {
                clearSearchButton.classList.remove('vendora-d-none');
                handleSearch(inputValue);
            } else {
                searchDropdown.classList.add('vendora-d-none');
                clearSearchButton.classList.add('vendora-d-none');
            }
        });

        clearSearchButton.addEventListener('click', () => {
            searchInput.value = '';
            searchInput.dispatchEvent(new Event('input', { bubbles: true }));
            searchInput.focus();
            searchDropdown.classList.add('vendora-d-none');
        });
    }
});
